const RETURN_URL_KEY = 'postLoginRedirect';

const PUBLIC_PREFIXES = ['/login', '/forgotPassw', '/setPassw', '/registration'];

export function isPublicPath(path) {
	const pathname = (path || '').split('?')[0];
	return PUBLIC_PREFIXES.some(
		prefix => pathname === prefix || pathname.startsWith(`${prefix}/`)
	);
}

export function toAppPath(location) {
	if (!location) {
		return getCurrentAppPath();
	}
	if (typeof location === 'string') {
		return location;
	}
	return `${location.pathname || '/'}${location.search || ''}`;
}

export function getCurrentAppPath() {
	const hash = window.location.hash || '';
	if (hash.startsWith('#/')) {
		return hash.slice(1);
	}
	return '/';
}

export function rememberReturnUrl(path) {
	if (!path || isPublicPath(path)) {
		return;
	}
	sessionStorage.setItem(RETURN_URL_KEY, path);
}

export function peekReturnUrl() {
	const stored = sessionStorage.getItem(RETURN_URL_KEY);
	if (!stored || isPublicPath(stored)) {
		return null;
	}
	return stored;
}

export function clearReturnUrl() {
	sessionStorage.removeItem(RETURN_URL_KEY);
}


export function redirectToLogin() {
	const current = getCurrentAppPath();
	if (isPublicPath(current)) {
		return;
	}
	
	window.location.replace(
		`${window.location.pathname}${window.location.search}#/login`
	);
}

export function redirectToForbidden() {
	const current = getCurrentAppPath();
	
	window.location.replace(
		`${window.location.pathname}${window.location.search}#/forbidden`
	);
}